import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/travel-time-to-work.png'

const DemographicsTravelTime = dynamic(() => import('src/components/insights/demographics/cards/travel-time'), {
  ssr: false,
})

export const DemographicsTravelTimeWidget: InsightBuilderWidget = {
  id: 'travel-time-to-work',
  name: 'Travel Time To Work',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsTravelTime,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
